import {
    GET_GAME_HIGHLIGHT_LIST,
    GAME_HIGHLIGHT_COLOURS,
    UPDATE_NEW_GAME_CHECKED,
    INIT_GAME_HIGHLIGHT_LIST,
    GAME_LIST,
    SET_ACTION,
    SET_LOADING,
    GAME_STOCK,
} from '../../actions/gameHighlights/gameHighlights';

const INITIAL_STATE = {
    loading: false,
    gameHighlightList: {
        content: [],
        totalElements: 0,
        totalPages: 0,
        size: 20,
        number: 0,
        loading: false,
    },
    gameHighlightsColours: [],
    newGameChecked: false,
    gameList: [],
    action: null,
    gameStock: [],
};
const gameHighlightsOptions = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INIT_GAME_HIGHLIGHT_LIST:
            return { ...INITIAL_STATE };

        case GET_GAME_HIGHLIGHT_LIST:
            return {
                ...state,
                gameHighlightList: action.payload,
            };

        case GAME_HIGHLIGHT_COLOURS:
            return {
                ...state,
                gameHighlightsColours: [...action.payload],
            };

        case UPDATE_NEW_GAME_CHECKED:
            return {
                ...state,
                newGameChecked: action.payload,
            };

        case GAME_LIST:
            return {
                ...state,
                gameList: [...action.payload],
            };
        case SET_ACTION:
            return {
                ...state,
                action: action.payload,
            };
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case GAME_STOCK:
            return {
                ...state,
                gameStock: action.payload,
            };
        default:
            return state;
    }
};
export default gameHighlightsOptions;
